export default __webpack_public_path__ + "static/media/guide@color.ac2172a0.svg";